import type {LokalisierungsProvider} from "@k/global/Localizer";
import {LogoPoolController} from "../controllerModules/logoPoolController";
import {EventListener, EventVerteiler} from "@k/global/eventVerteiler";
import {SELOBEVENTNAMES} from "@k/global/GlobalEventnames";
import {HTMLPrinter} from "@k/global/htmlprinter";
import {LogoFileUpload} from "./logoFileUpload";
import globalsObject, {translate} from "../globalsObject";
import {ImageLazyLoader} from "../LazyLoader";
import {RahmenTabsDialogDisplayer} from "./rahmenTabsDialogDisplayer";
import {arrayIndexByKeyValue} from "@k/global/arrayHelper";
import {LogoPoolEntry} from "../databaseInterfaceClasses";
import {StringDictionary} from "@k/js/delme_globals";

const OWAYO_COOKIES_ENABLED = true;

export class Logopool extends EventListener {
    private readonly logoPoolController: LogoPoolController;
    // private readonly freistellerComponent: FreistellerViewComponent;

    private lazyLoader:ImageLazyLoader|null = null;
    public constructor(logoPoolController:LogoPoolController, localizer:LokalisierungsProvider) {
        super();
        this.logoPoolController = logoPoolController;
        new LogoFileUpload(logoPoolController, localizer);
        this.initEventListeners();
        this.initButtonEventListeners();

        // this.freistellerComponent = new FreistellerViewComponent(ajaxResponse=>controller.logoUploaded(ajaxResponse));
    }

    private static getMonthYearStringFromDatabaseTimeString(databaseTimeString:string){
        const parts = databaseTimeString.split("-");
        return [parts[1], parts[0]].join("/");
    }

    private static removeLogoEntryForImage(img:HTMLImageElement) {
        $(img).parent().parent().remove();
        // console.log("removed unloaded logo " + img.dataset.filename);
    }

    private initEventListeners() {
        this.addEventListener("initLogoPoolEvent", (data)=>this.initLogoPool(data.logos))
            .addEventListener("logoPoolItemsRemotelyAddedEvent", (data)=>{
                if(this.lazyLoader === null) {
                    this.lazyLoader = new ImageLazyLoader([], Logopool.removeLogoEntryForImage)
                }
                this.addNewLogoThumbnails(data.newLogos)
            })
            .addEventListener("logoPoolItemsDeletedEvent", (data)=>this.logoPoolItemsDeleted(data))
            .addEventListener("resetFileUploadEvent", ()=>this.initLogoPool(globalsObject.controller.model.logoPool.getLogos()))
            .addEventListener("userLoggedOutEvent", ()=>this.initLogoPool([]))
            .addEventListener("allLogoPreviewsArrivedEvent", ()=>Logopool.deleteLogoThumbnails("logoLoading"))
            .addEventListener("directlyCreateLogoEvent", ({type, id})=>{
                const logoPoolEntry = this.logoPoolController.getLogoPoolEntryByTypeAndID(type, id);
                this.createLogo(logoPoolEntry as LogoPoolEntry)
            })
    }

    private static removeAllLogoEntries() {

        document.querySelectorAll(".logo-upload-content .logo-date-row").forEach(e=>e.remove());
    }

    private initLogoHandlerClickHandler(logos:LogoPoolEntry[]) {
        const $this = this;
        logos.forEach(entry=>{
            $(".logoDelete[data-filename='"+entry.filename+"']").on("click", function(){$this.logoPoolController.deleteLogoPoolEntry(entry);});

            $(".logo-box-image[data-filename='"+entry.filename+"'], .logoTake[data-filename='"+entry.filename+"']").on("click", function(){
                $this.logoPoolItemClickedEventHandler(entry);
            });
        })

    }

    initLogoPool (logos:LogoPoolEntry[]) {
        if(this.lazyLoader !== null) {
            this.lazyLoader = null;
        }
        Logopool.removeAllLogoEntries();

        if (!OWAYO_COOKIES_ENABLED) {
            Logopool.disableLogoSwiperBecauseNoCookies();
            return;
        }
        if(logos.length === 0) {
            return;
        }
        $(".logo-upload-content .intro").after(Logopool.getLogoDateRowsHtml(Logopool.sortIntoArraysByDate(logos)));
        this.initLogoHandlerClickHandler(logos);


        this.lazyLoader = new ImageLazyLoader($(".logo-upload-content .lazyload").toArray() as HTMLImageElement[], Logopool.removeLogoEntryForImage);
    }

    logoPoolItemsDeleted(data:{deletedLogos:LogoPoolEntry[]}) {
        const $this = this;
        data.deletedLogos.forEach(function(logo:LogoPoolEntry){
            $this.lazyLoader?.unobserve($(".logo-upload-content img[src='"+logo.thumbnailURL+"']")[0] as HTMLImageElement);
            $(".overlay-logo-upload").find(".logo-box[data-filename='" + logo.filename + "'][data-type='"+logo.type+"']")
            .addClass("deleted");
        });

        Logopool.deleteLogoThumbnails("deleted");
    }

    public addNewLogoThumbnails (logoPoolEntries:LogoPoolEntry[]) {
        const notLoadedEntries = Logopool.eliminateAlreadyLoadedFilenamesFromArray(logoPoolEntries);
        if (notLoadedEntries.length === 0) {
            return;
        }
        const $this = this;
        logoPoolEntries.forEach((entry:LogoPoolEntry)=>{
            const date = Logopool.getMonthYearStringFromDatabaseTimeString(typeof(entry as LogoPoolEntry).addedDate !== "undefined" ? (entry as LogoPoolEntry).addedDate : new Date().toISOString());
            const logorow = $(".logo-date-row:contains('"+date+"')");
            if(logorow.length > 0) {
                const loadingDivForLogo = LogoPoolHTMLPrinter.createLazyLoadingDivForLogo(entry);
                logorow.find("h3").after(loadingDivForLogo);
            } else {
                const param = [] as unknown as StringDictionary<LogoPoolEntry[]>;
                param[date]=[entry];
                const html = Logopool.getLogoDateRowsHtml(param);
                $(".logo-upload-content .intro").after(html);
            }
            $(".logoDelete[data-filename='"+entry.filename+"']").on("click", function(){$this.logoPoolController.deleteLogoPoolEntry(entry);});

            $(".logo-box-image[data-filename='"+entry.filename+"'], .logoTake[data-filename='"+entry.filename+"']").on("click", function(){
                $this.logoPoolItemClickedEventHandler(entry);
            });
            if(this.lazyLoader === null) {
                this.lazyLoader = new ImageLazyLoader([], Logopool.removeLogoEntryForImage);
            }
            ($this.lazyLoader as ImageLazyLoader).observe($("img[data-filename='"+entry.filename+"']")[0] as HTMLImageElement);
        });
    }
    private static deleteLogoThumbnails (cssClass = "logoLoading") {
        $(".logo-upload-content ." + cssClass).remove();
        // $(".logo-date-row:not(:has('img'))").remove();
    }

    private logoPoolItemClickedEventHandler(currentLogo:LogoPoolEntry) {

        if(currentLogo.isAILogo && arrayIndexByKeyValue(this.logoPoolController.model.getCurrentOwayoProduct().selectedFeatures, 'featuredObject', 'Bedruckung KI Logo')<0){
                RahmenTabsDialogDisplayer.displayUserInteractionDialog(
                    "warn",
                    globalsObject.localizer.translate("konf_warning", "Achtung"),
                    globalsObject.localizer.translate("konf_aiLogoNotAllowed", "Auf dieses Produkt kann derzeit kein KI Logo gelegt werden."));
                return;
            }

            if(currentLogo.isAILogo && arrayIndexByKeyValue(this.logoPoolController.model.getCurrentOwayoProduct().selectedFeatures, 'featuredObject', 'Bedruckung KI Logo')<0){
                RahmenTabsDialogDisplayer.displayUserInteractionDialog(
                    "warn",
                    globalsObject.localizer.translate("konf_warning", "Achtung"),
                    globalsObject.localizer.translate("konf_aiLogoNotAllowed", "Auf dieses Produkt kann derzeit kein KI Logo gelegt werden."));
                return;
            }

        const overlayUpload = $(".overlay-logo-upload");
        if(!overlayUpload.hasClass("active")) {
            return; //verhindert doppelKlick
        }
        const logo = this.logoPoolController.createLogoObject(currentLogo);
        this.logoPoolController.model.entwurf.getLogoObjects().push(logo);
        EventVerteiler.broadcast(SELOBEVENTNAMES.CREATED, logo);
        EventVerteiler.broadcast("displayHintEvent","HINT_LOGOOBJECT_CREATED");
        overlayUpload.removeClass("active");
    }

    private createLogo(currentLogo:LogoPoolEntry) {
        const logo = this.logoPoolController.createLogoObject(currentLogo);
        this.logoPoolController.model.entwurf.getLogoObjects().push(logo);
        EventVerteiler.broadcast(SELOBEVENTNAMES.CREATED, logo);
        EventVerteiler.broadcast("displayHintEvent","HINT_LOGOOBJECT_CREATED");
        $(".overlay-logo-upload").removeClass("active");
    }

    // noinspection JSJQueryEfficiency
    private static disableLogoSwiperBecauseNoCookies = ()=>$(".logo-upload-content").empty().text(LogoPoolHTMLPrinter.getNoCookieMessage());

    private static eliminateAlreadyLoadedFilenamesFromArray (entries : LogoPoolEntry[]) : LogoPoolEntry[] {
        return entries.filter(
            entry=>$(".logo-box-image[data-filename='"+entry.filename + "']", $(".logo-upload-content")).length === 0);
    }

    private static getLogoDateRowsHtml(sortedByDate:StringDictionary<LogoPoolEntry[]>): string {
        const out = [] as string[];
        for (const date in sortedByDate) {
            out.push(LogoPoolHTMLPrinter.getLogoDateRowWithLazyLoading(date, sortedByDate))
        }
        return HTMLPrinter.collection(out);
    }

    private static sortIntoArraysByDate(logos:LogoPoolEntry[]) {
        return logos.reduce(function (carry, l) {
            const date = Logopool.getMonthYearStringFromDatabaseTimeString(l.addedDate);
            if (typeof (carry[date]) === "undefined") {
                carry[date] = [];
            }
            carry[date].push(l);
            return carry;
        }, [] as unknown as StringDictionary<LogoPoolEntry[]>);
    }

    private initButtonEventListeners() {
        $(".overlay-logo-upload .btn-close").on("click", ()=>$(".overlay-logo-upload").removeClass("active"));
    }
}

export class LogoPoolHTMLPrinter {
    public static getLogoDateRowWithLazyLoading(date:string, sortedByDate:StringDictionary<LogoPoolEntry[]>) {
        const p = HTMLPrinter;
        return p.divWitHProps(p.cssClass("logo-date-row"))(
            p.h3(date),
            p.collection(sortedByDate[date].map((l:LogoPoolEntry) => LogoPoolHTMLPrinter.createLazyLoadingDivForLogo(l)))
        );
    }

    public static createLazyLoadingDivForLogo(logoPoolEntry:LogoPoolEntry) {
        const p = HTMLPrinter;
        const uploadedByOwayoClass = (logoPoolEntry.uploadedByOwayo) ?"owayoUpload" : "";
        const dataFilenameProp = p.dataProp("filename")(logoPoolEntry.filename);
        const dataTypeProp = p.dataProp("type")(logoPoolEntry.type);
        return p.divWitHProps(p.cssClass("logo-box"), dataFilenameProp, dataTypeProp)(
            p.divWitHProps(p.cssClass("logo-box-image", uploadedByOwayoClass), dataFilenameProp, dataTypeProp)(
                p.divWitHProps(p.cssClass('logo-img-wrapper'))(
                p.img(p.alt("loadingGif"), p.src("img/ajax-loader.gif"), p.dataProp("src")(logoPoolEntry.thumbnailURL), p.cssClass("lazyload", "logothumbnail checkered"),dataFilenameProp,
                    dataTypeProp, p.dataProp("alt")(logoPoolEntry.filename))
            )
            ),
            p.divWitHProps(p.cssClass("logo-box-action"))(
                p.buttonWithProps(p.cssClass("logoTake"), dataFilenameProp, dataTypeProp)(""),
                p.buttonWithProps(p.cssClass("btn-delete-popup logoDelete"), dataFilenameProp, dataTypeProp)("")
            )
        );

    }

    public static getNoCookieMessage() {
        const p = HTMLPrinter;
        return p.collection(
            p.divWitHProps(p.cssClass("logoSwiperNoCookies"))(
                translate(
                    "konf_disabledBecauseNoCookies",
                    "Diese Funktion funktioniert leider nur wenn Cookies verwendet werden können."
                )
            ),
            p.div(
                translate(
                    "konf_pleaseAllowCookies",
                    "Bitte erlauben Sie die Benutzung von Cookies und laden Sie den Konfigurator neu."
                )
            )
        )
    }
}
